/* eslint-disable camelcase */
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DoctorPhoto } from '../../components/DoctorPhoto/DoctorPhoto';
import {
    dateAndMonth,
    doctorAudience,
    formatDate,
    formatFullDate,
    formatTime,
    getDayName,
    sortBy,
    toPascalCase,
} from '../../utils';
import { selectDate, selectDoctor } from '../filters/filtersSlice';
import { PhoneList } from '../../components/PhoneList/PhoneList';
import { selectTimeslots } from './selectors';
import { selectFilters } from '../filters/selectors';
import { clearDoctorBookingError } from '../bookingForm/bookingFormSlice';
import { fetchTimeslots } from './doctorsSlice';
import { useWidgetProps } from '../../WidgetPropsContext';
import { isFutureTimeslot } from '../../serviceBooking/util/timeSlots';
import { TimeDiff } from '../../serviceBooking/ServiceBookingForm/DoctorList/DoctorListItem/TimeslotList/TimesotList';

export const REGISTRY_NAME = 'Нет свободных слотов';

const doctorItem = require('b_').with('doctor-item');
const link = require('b_').with('link');

// const sortTimeslots = ({ startTime: a }, { startTime: b }) => {
//     return new Date(a.trim().split(' ').join('T')).getTime() - new Date(b.trim().split(' ').join('T')).getTime();
// };

const NearestTimeslot = React.memo(({
    nearestTimeslot, freeTimeslots, onDate, onRegistry,
}) => {
    const shouldRenderNearestTimeslot = nearestTimeslot && freeTimeslots?.length === 0;
    const shouldRenderBookingNotAvailable = !nearestTimeslot && freeTimeslots.length === 0;
    return (
        <>
            {!shouldRenderNearestTimeslot ? null : (
                <span className={doctorItem('desc', { 'nearest-date': true })}>
                    Ближайшая датa:{' '}
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <span onClick={onDate} className={link()}>
                        {formatDate(nearestTimeslot)}
                    </span>
                </span>
            )}
            {!shouldRenderBookingNotAvailable ? null : (
                <span className={doctorItem('desc', { 'nearest-date': true })}>
                    Ближайшая датa:{' '}
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <span className={doctorItem('normal')}>
                        {REGISTRY_NAME || 'В регистратуре'}
                    </span>
                </span>
            )}
        </>
    );
});

// const doctorItemDataMaker = (props, historyState) => {
//     return {
//         fullName: props.fullName || historyState.fullName,
//         specialityName: props.specialityName || historyState.specialityName,
//         children: props.children || historyState.children,
//         childrenAge: props.childrenAge || historyState?.childrenAge,
//         adult: props.adult || historyState.adult,
//         nearestTimeslot: props.nearestTimeslot || historyState?.nearestTimeslot,
//         freeTimeslots: props.freeTimeslots || historyState.freeTimeslots,
//         date: props.date || historyState.date,
//         doctorId: props.doctorId || historyState.doctorId,
//         description: props.description || historyState.description,
//         photoLink: props.photoLink || historyState.photoLink,
//         assignments: props.assignments || historyState.assignments,
//     };
// };
//
export const DoctorItem = (props) => {
    const [ isTimeslotsVisible, toggleTimeslotsVisibility ] = useState(false);
    const [ isDescriptionVisible, toggleDescriptionVisibility ] = useState(false);
    const [ showRegistry, setShowRegistry ] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const { state = {} } = useLocation();
    const { timeslotId: activeTimeslotId } = useParams();
    const { timetableData } = useSelector(selectTimeslots);
    const [ freeTimeslots, setFreeTimeslots ] = useState([]);
    const {
        doctor: selectedDoctor,
        specialization: selectedSpecialization,
        doctorsData,
        branch: selectedBranch,
    } = useSelector(selectFilters);

    const { baseUrl } = useWidgetProps();

    const {
        fullName,
        specialityName,
        children,
        childrenAge,
        adult,
        nearestTimeslot,
        freeTimeslots: freeTimeslotsProps,
        date,
        doctorId,
        description,
        photoLink,
        assignments,
        online,
        adult_age_to,
        adult_age,
        children_age_to,
    } = props;

    const getFreeTimeslots = () => {
        // if (doctorId && timetableData && timetableData[doctorId]) {
        if (selectedDoctor && timetableData && timetableData[doctorId]) {
            return sortBy(
                timetableData[doctorId]?.filter(
                    ({ startTime }) => formatFullDate(startTime) === date && isFutureTimeslot(startTime),
                ) ?? [],
                'timeslotId',
            );
        }

        return freeTimeslotsProps;
    };

    useEffect(() => {
        const slots = getFreeTimeslots() ?? [];
        setFreeTimeslots(slots);
    }, [ date, freeTimeslotsProps, timetableData, doctorId, selectedDoctor ]);

    const onTimeslot = (id) => {
        dispatch(clearDoctorBookingError());
        const url = `/timeslot/${id}`;
        const obj = {
            ...state,
            fullName,
            specialityName,
            children,
            childrenAge,
            childrenAgeTo: children_age_to,
            adultAge: adult_age,
            adultAgeTo: adult_age_to,
            adult,
            nearestTimeslot,
            freeTimeslots,
            date,
            online,
            doctorId: assignments?.length ? assignments[0] : doctorId,
            errorMessage: undefined,
        };
        history.replace(url, obj);
        if (!selectedSpecialization) {
            const specializationId = doctorsData.find(({ doctorId: docId }) => docId === doctorId)?.specialityId;
            dispatch(
                fetchTimeslots({
                    branch: selectedBranch,
                    date,
                    baseUrl,
                    specializationId,
                }),
            );
        }

        dispatch(selectDoctor(doctorId));
    };

    const onDate = useCallback(() => {
        dispatch(selectDoctor(doctorId));
        dispatch(selectDate(formatFullDate(nearestTimeslot)));
    }, [ doctorId, nearestTimeslot, dispatch ]);

    const onRegistry = useCallback(() => {
        dispatch(selectDoctor(doctorId));
        setShowRegistry(prevState => !prevState);
    }, [ doctorId, nearestTimeslot, dispatch ]);

    return (
        <li className={doctorItem()}>
            <div className={doctorItem('intro', { main: true })}>
                <div className={doctorItem('container')}>
                    <div className={doctorItem('photo-container')}>
                        <DoctorPhoto photoLink={photoLink}/>
                    </div>
                </div>
                <div className={doctorItem('info')}>
                    <header className={doctorItem('info-header')}>
                        <h4 className={doctorItem('desc', { name: true })}>{fullName}</h4>
                    </header>
                    <main className={doctorItem('info-body')}>
                        <span className={doctorItem('desc')}>{toPascalCase(specialityName)}</span>
                        <span className={doctorItem('desc')}>
                            Принимает:{' '}
                            {doctorAudience({
                                children,
                                childrenAge,
                                adult,
                                adultAgeTo: adult_age_to,
                                adultAge: adult_age,
                                childrenAgeTo: children_age_to,
                            })}
                        </span>
                    </main>
                </div>
            </div>
            <div className={doctorItem('intro')}>
                {!description ? null : (
                    <div
                        className={doctorItem('desc', {
                            more: true,
                            'is-opened': isDescriptionVisible,
                        })}>
                        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                        <span onClick={() => toggleDescriptionVisibility(!isDescriptionVisible)} className={link()}>
                            Подробнее
                        </span>
                        <p className={doctorItem('desc')}>{description}</p>
                    </div>
                )}
                <NearestTimeslot
                    nearestTimeslot={nearestTimeslot}
                    freeTimeslots={freeTimeslots}
                    onDate={onDate}
                    onRegistry={onRegistry}
                />
                {freeTimeslots?.length === 0 ? null : (
                    <div className={doctorItem('timeslots-container')}>
                        <span className={doctorItem('desc', { 'nearest-date': true })}>
                            {`${dateAndMonth(date)} - ${getDayName(date)}`}
                            <TimeDiff/>
                        </span>
                        <ul className={doctorItem('timeslots', { 'is-opened': isTimeslotsVisible })}>
                            {[...(freeTimeslots ?? [])]
                                // .sort(sortTimeslots)
                                .map(({ startTime, timeslotId }) => (
                                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                                    <li
                                        key={timeslotId}
                                        className={doctorItem('timeslot', { active: +activeTimeslotId === +timeslotId })}
                                        onClick={() => onTimeslot(timeslotId)}>
                                        {formatTime(startTime)}
                                    </li>
                                ))}
                        </ul>
                        {freeTimeslots?.length <= 5 ? null : (
                            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                            <a
                                className={doctorItem('timeslots-toggler', { rotate: isTimeslotsVisible })}
                                onClick={() => toggleTimeslotsVisibility(prevState => !prevState)}>
                                {`Показать ${isTimeslotsVisible ? 'меньше' : 'больше'} таймслотов для записи`}
                            </a>
                        )}
                    </div>
                )}
                {!!showRegistry && <PhoneList label="Номера регистратуры"/>}
            </div>
        </li>
    );
};
